import React, { useEffect, useRef, useState } from "react";
import "./Hourglass.css";
import { Box } from "@mui/system";

const FIFTEEN_MINUTES = 15 * 60;

const Hourglass: React.FC = () => {
  const [seconds, setSeconds] = useState(FIFTEEN_MINUTES);
  const [flipCount, setFlipCount] = useState(0);
  const flipCardsRef = useRef<NodeListOf<Element>>();

  // 🔥 Auto date (Today + 3 Days)
const futureDate = new Date();
futureDate.setDate(futureDate.getDate() + 3);

const formattedDate = futureDate.toLocaleDateString("en-GB", {
  day: "numeric",
  month: "long",
  year: "numeric",
});

  /* ---------------- TIMER LOGIC (UNCHANGED) ---------------- */
  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => {
        if (prev <= 1) {
          setFlipCount((f) => f + 1);
          return FIFTEEN_MINUTES;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  /* ---------------- FLIP DISPLAY CONTROL ---------------- */
  useEffect(() => {
    flipCardsRef.current = document.querySelectorAll(".flip-card");
    if (!flipCardsRef.current) return;

    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;

    flipCardsRef.current[0].setAttribute(
      "style",
      `--minutes:${minutes}`
    );

    flipCardsRef.current[1].setAttribute(
      "style",
      `--seconds:${secs}`
    );

    // Animate seconds every tick
    startAnimation(1);

    // Animate minutes only when changed
    if (secs === 59) {
      startAnimation(0);
    }

  }, [seconds]);

  function startAnimation(n: number) {
    if (!flipCardsRef.current) return;

    const flip = flipCardsRef.current[n].querySelectorAll("[data-flip]");
    const top = flip[0] as HTMLElement;
    const bottom = flip[1] as HTMLElement;

    top.dataset.flip = "true";
    bottom.dataset.flip = "true";

    top.addEventListener(
      "animationend",
      () => {
        bottom.addEventListener(
          "animationend",
          () => {
            top.dataset.flip = "false";
            bottom.dataset.flip = "false";
          },
          { once: true }
        );
      },
      { once: true }
    );
  }

  return (
    <Box className="wrapper">

      {/* <Box className="event-minimal">
        <p className="mini-tag">LIVE MASTERCLASS</p>

        <h1 className="premium-title">
          <span className="highlight">2-Hour</span> Online
          <br />
          Workshop
        </h1>

        <div className="line-accent"></div>

        <p className="event-date">{formattedDate}</p>
        <p className="event-time">11:00 AM — 1:00 PM</p>
      </Box> */}

      {/* HOURGLASS (UNCHANGED LOGIC) */}
      {/* <Box
        className="hourglass"
        sx={{mt:5}}
        style={{
          transform: `rotate(${flipCount * 180}deg)`,
          ["--duration" as any]: `${FIFTEEN_MINUTES}s`,
        }}
      >
        <Box className="top-glass">
          <Box className="sand-top"></Box>
        </Box>

        <Box className="drip"></Box>

        <Box className="bottom-glass">
          <Box className="sand-bottom"></Box>
        </Box>
      </Box> */}

      {/* EXACT COUNTDOWN STRUCTURE */}
      <Box className="container">
        <Box className="content-grid two">
          <Box className="flip-card">
            <span className="top" data-flip="false"></span>
            <span className="bottom" data-flip="false"></span>
          </Box>

          <Box className="flip-card">
            <span className="top" data-flip="false"></span>
            <span className="bottom" data-flip="false"></span>
          </Box>

          <Box className="card-title">Minutes</Box>
          <Box className="card-title">Seconds</Box>
        </Box>
      </Box>


    </Box>
  );
};

export default Hourglass;